import axios from 'axios';
const path = id => `/api/running/${encodeURIComponent(id)}/product-mappings`;
export const getProductMappings = async (id, config) => (await axios.get(path(id), config)).data;
export const saveProductMappings = async (id, payload) => (await axios.patch(path(id), payload)).data;
export const getMappingProducts = async (organization, config = {}) => (await axios.get('/api/products', {
  ...config, params: { organization, active: 'all' }
})).data;
